/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { Divider, Text, View } from '@az/starc-ui';
import { useTimeAgo } from '../../../hooks/useTimeAgo';
import { useLabels } from '@/hooks/useLabels';

type AuthorProps = {
  nickname: string;
  date: string;
};

const labelMap = {
  anonymous: 'label_reviews_anonymous',
};

export const Author = ({ nickname, date }: AuthorProps) => {
  const { getPostedDate } = useTimeAgo();
  const labels = useLabels(labelMap);
  const postedDate = getPostedDate(date);

  return (
    <View className={styles.authorDetails}>
      <Text variant="main-body" className={styles.nickname}>
        {nickname ? nickname : labels.anonymous}
      </Text>
      <View.Item attributes={{ 'aria-hidden': true }}>
        <Divider vertical />
      </View.Item>
      <Text variant="small-body" className={styles.date}>
        {postedDate}
      </Text>
    </View>
  );
};
